// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.sold-out {
  position: absolute;
  left: 25px;
  top: 10px;
  z-index: 9999;
}
.sold-out ion-icon {
  height: 30px;
  width: 66px;
  z-index: 99;
}

.item-row {
  height: 100%;
  border-radius: 12px;
  padding: 20px 7%;
  position: relative;
  overflow: hidden;
  transition: border 0.2s ease-in-out;
  border: 1px solid var(--accent-color);
  cursor: pointer;
}
.item-row.inactive {
  opacity: 0.3;
  pointer-events: none;
  cursor: default;
}
.item-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.new {
  position: absolute;
  height: 25px;
  width: 60px;
  top: 15px;
  right: 20px;
  z-index: 1;
}

.img-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.img-wrapper.block-adding ion-img {
  opacity: 0.3;
}
.img-wrapper.block-adding ion-icon {
  position: absolute;
  top: 10px;
  right: -15px;
  transform: translate(-50%, -50%);
  z-index: 99;
  width: 25px;
  height: 25px;
  opacity: 0.3;
}

.item-image {
  width: 80%;
  aspect-ratio: 1;
  margin-bottom: 10px;
}

.cover-image {
  object-fit: contain;
}

.item-name {
  text-align: start;
  margin: 0 0 7px;
}

.item-info {
  text-align: start;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 10px;
}

.price-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.price-row .kcall {
  position: relative;
  font-size: 14px;
  line-height: 16.8px;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
}
.price-row .kcall,
.price-row .tags {
  position: relative;
  height: 17px;
  margin-left: 12px;
}
.price-row .kcall::before,
.price-row .tags::before {
  content: "";
  position: absolute;
  left: -6px;
  width: 1.5px;
  height: 100%;
  background: var(--color-black);
}

.buttons {
  margin-top: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.buttons ion-button {
  width: 65%;
  --border-width: 1px;
  min-height: 32px;
  text-wrap: auto;
  background: transparent;
  color: var(--accent-color);
}
.buttons ion-button:hover {
  color: #fff;
}
.buttons .add-button {
  --background: var(--ion-color-primary);
  --color: white;
  min-height: 30px !important;
  height: 30px !important;
}
.buttons .add-button.not-enought {
  opacity: 0.3;
}
.buttons .add-icon-wrap {
  width: 48%;
  display: flex;
  justify-content: flex-start;
}
.buttons .add-icon-wrap.center-align {
  justify-content: center;
}
.buttons .not-enough {
  --color: var(--color-black);
  opacity: 0.5;
}
.buttons .not-enough ion-icon {
  margin-right: 10px;
}

.progress-bar {
  position: absolute;
  bottom: -20px;
  width: 120%;
  --progress-background: #F48B7F;
  --buffer-background: #EBDFDA;
}

.add-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ebdfda;
}
.add-icon:hover {
  background: #f2dbd9;
}
.add-icon ion-icon {
  margin: 0px;
  color: var(--color-black);
  width: 40px;
  height: 40px;
}

.amount-in-basket {
  position: absolute;
  display: flex;
  align-items: center;
  background: #F2DBD9;
  border-radius: 20px;
  top: 15px;
  left: 15px;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  height: 20px;
}
.amount-in-basket ion-icon {
  width: 20px;
  height: 20px;
}
.amount-in-basket p {
  padding: 0px 10px 0px 5px;
  color: var(--color-black);
  font-family: AppFont, sans-serif;
}

.info-icon {
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-view/item-view.component.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;EACA,YAAA;AADF;;AAIA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;AADF;AAGE;EACE,YAAA;EACA,WAAA;EACA,WAAA;AADJ;;AAKA;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,qCAAA;EACA,eAAA;AAFF;AAIE;EACE,YAAA;EACA,oBAAA;EACA,eAAA;AAFJ;AAqBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAnBF;;AAsBA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAnBF;AAuBI;EACE,YAAA;AArBN;AAwBI;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAtBN;;AA2BA;EACE,UAAA;EACA,eAAA;EACA,mBAAA;AAxBF;;AA2BA;EACE,mBAAA;AAxBF;;AA2BA;EACE,iBAAA;EACA,eAAA;AAxBF;;AA2BA;EACE,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,gBAAA;EAEA,mBAAA;AA1BF;;AA6BA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,mBAAA;AA3BF;AA8BE;EACE,kBAAA;EAEA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AA7BJ;AAgCE;;EAEE,kBAAA;EACA,YAAA;EACA,iBAAA;AA9BJ;AAiCE;;EAEE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;AA/BJ;;AAmCA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAhCF;AAkCE;EACE,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,0BAAA;AAhCJ;AAiCI;EACE,WAAA;AA/BN;AAmCE;EACE,sCAAA;EACA,cAAA;EACA,2BAAA;EACA,uBAAA;AAjCJ;AAmCI;EACE,YAAA;AAjCN;AAqCE;EACE,UAAA;EACA,aAAA;EACA,2BAAA;AAnCJ;AAqCI;EACE,uBAAA;AAnCN;AAuCE;EACE,2BAAA;EACA,YAAA;AArCJ;AAuCI;EACE,kBAAA;AArCN;;AA2CA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,8BAAA;EACA,4BAAA;AAxCF;;AA2CA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAxCF;AA0CE;EACE,mBAAA;AAxCJ;AA4CE;EACE,WAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;AA1CJ;;AA8CA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EAEA,mBAAA;EAEA,SAAA;EACA,UAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;EACA,YAAA;AA7CF;AA+CE;EACE,WAAA;EACA,YAAA;AA7CJ;AAgDE;EACE,yBAAA;EACA,yBAAA;EACA,gCAAA;AA9CJ;;AAkDA;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AA/CF","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n  display: block;\n  height: 100%;\n}\n\n.sold-out {\n  position: absolute;\n  left: 25px;\n  top: 10px;\n  z-index: 9999;\n\n  ion-icon {\n    height: 30px;\n    width: 66px;\n    z-index: 99;\n  }\n}\n\n.item-row {\n  height: 100%;\n  border-radius: 12px;\n  padding: 20px 7%;\n  position: relative;\n  overflow: hidden;\n  transition: border 0.2s ease-in-out;\n  border: 1px solid var(--accent-color);\n  cursor: pointer;\n\n  &.inactive {\n    opacity: 0.3;\n    pointer-events: none;\n    cursor: default;\n  }\n\n  &.isAdded {\n\n    //border: 1px solid var(--color-black);\n  }\n\n  // @include mobile {\n  //   margin-bottom: 12px;\n  // }\n}\n\n.item-row:hover {\n  // ion-button {\n  // \t--background: #f2dbd9;\n  // }\n}\n\n.item-col {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.new {\n  position: absolute;\n  height: 25px;\n  width: 60px;\n  top: 15px;\n  right: 20px;\n  z-index: 1;\n}\n\n.img-wrapper {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n\n  &.block-adding {\n\n    ion-img {\n      opacity: 0.3;\n    }\n\n    ion-icon {\n      position: absolute;\n      top: 10px;\n      right: -15px;\n      transform: translate(-50%, -50%);\n      z-index: 99;\n      width: 25px;\n      height: 25px;\n      opacity: 0.3;\n    }\n  }\n}\n\n.item-image {\n  width: 80%;\n  aspect-ratio: 1;\n  margin-bottom: 10px;\n}\n\n.cover-image {\n  object-fit: contain;\n}\n\n.item-name {\n  text-align: start;\n  margin: 0 0 7px;\n}\n\n.item-info {\n  text-align: start;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n\n  overflow: hidden;\n\n  margin-bottom: 10px;\n}\n\n.price-row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  margin-bottom: 20px;\n\n\n  .kcall {\n    position: relative;\n\n    font-size: 14px;\n    line-height: 16.8px;\n    letter-spacing: 0%;\n    text-align: center;\n    text-transform: uppercase;\n  }\n\n  .kcall,\n  .tags {\n    position: relative;\n    height: 17px;\n    margin-left: 12px;\n  }\n\n  .kcall::before,\n  .tags::before {\n    content: '';\n    position: absolute;\n    left: -6px;\n    width: 1.5px;\n    height: 100%;\n    background: var(--color-black);\n  }\n}\n\n.buttons {\n  margin-top: auto;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n\n  ion-button {\n    width: 65%;\n    --border-width: 1px;\n    min-height: 32px;\n    text-wrap: auto;\n    background: transparent;\n    color: var(--accent-color);\n    &:hover {\n      color: #fff;\n    }\n  }\n\n  .add-button {\n    --background: var(--ion-color-primary);\n    --color: white;\n    min-height: 30px !important;\n    height: 30px !important;\n\n    &.not-enought {\n      opacity: 0.3;\n    }\n  }\n\n  .add-icon-wrap {\n    width: 48%;\n    display: flex;\n    justify-content: flex-start;\n\n    &.center-align {\n      justify-content: center;\n    }\n  }\n\n  .not-enough {\n    --color: var(--color-black);\n    opacity: 0.5;\n\n    ion-icon {\n      margin-right: 10px;\n    }\n  }\n\n}\n\n.progress-bar {\n  position: absolute;\n  bottom: -20px;\n  width: 120%;\n  --progress-background: #F48B7F;\n  --buffer-background: #EBDFDA;\n}\n\n.add-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #ebdfda;\n\n  &:hover {\n    background: #f2dbd9;\n\n  }\n\n  ion-icon {\n    margin: 0px;\n    color: var(--color-black);\n    width: 40px;\n    height: 40px;\n  }\n}\n\n.amount-in-basket {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  background: #F2DBD9;\n\n  border-radius: 20px;\n  // top: auto;\n  top: 15px;\n  left: 15px;\n  width: fit-content;\n  margin: 0 auto;\n  height: 20px;\n\n  ion-icon {\n    width: 20px;\n    height: 20px;\n  }\n\n  p {\n    padding: 0px 10px 0px 5px;\n    color: var(--color-black);\n    font-family: AppFont, sans-serif;\n  }\n}\n\n.info-icon {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
